import React from "react";

// import ledBlue from "./led_blue.png";
import ledGreen from "./led_green.png";
// import ledGrey from "./led_grey.png";
import ledRed from "./led_red.png";
import ledYellow from "./led_yellow.png";

interface Props {
  status: string;
}

function StatusLed(props: Props) {
  const { status } = props;
  if (status === "ALARM") {
    return <img src={ledRed} alt="Alarm" />;
  }
  if (status === "EVENT") {
    return <img src={ledYellow} alt="Warning" />;
  }
  return <img src={ledGreen} alt="OK" />;
}

export default StatusLed;
